<span class="detail-bar"></span>
<header class="header-top" (mouseleave)="offClickHandler()">
  <div class="side-left">
    <button class="button-open-menu" aria-label="Abre menu lateral" id="open-sidebar-account" type="button"
      (click)="openMenu()">
    </button>
    <div class="logo-acesso">
      <a [href]="baseUrl"><img src="/assets/images/logo-unico-people.svg" alt="Logomarca unico | people"></a>
    </div>
    <p class="account-name" *ngIf="isLoggedIn">{{currentAccount?.name}}</p>
  </div>
  <div class="notification-content" #container>
    <div class="user-infos">
      <a href="https://paracolaboradores-skill.unico.io/" aria-label="Central de Ajuda" class="helper-link"
        rel="noopener" target="_blank"><img src="./assets/images/ico-help.svg" alt="Ícone da Central de Ajuda"></a>
      <span class="logo-user"><img src="/assets/images/user.svg" alt="Ícone de avatar do usuário"></span>
      <span class="username-header" (click)="logoutBox = !logoutBox" role="button"
        aria-label="Abre o menu do usuário">{{user?.user_name}}</span>
      <a (click)="logoutBox = !logoutBox" class="open-settings">open</a>
    </div>
    <ul id="logout" class="logout-box" [hidden]="logoutBox" #dropdown>
      <li class="logout"><a (click)="logout()">Sair</a></li>
    </ul>
  </div>
</header>